<template>
    <div v-if="loaded">
        <div v-cloak class="videosWidgetWrap">
            <div class="videosWidget">
                <div v-for="(video, index) in loaded_videos" class="videoItem" :style="{ backgroundImage: 'url(\'' + video.cover_image.sizes['videos-cover-image'] + '\')', 'background-size' : 'cover', 'background-position' : 'center', 'background-repeat' : 'no-repeat' }" @click="openVideo(video.video.link)">
                    <div v-if="index == 0" class="textGroup textGroupLarge">
                        <div class="playCircle">
                            <i class="fas fa-play"></i>
                        </div>
                        <h3>Play</h3>
                        <h3 class="boldHeading">Video</h3>
                    </div>
                    <div v-else class="textGroup">
                        <div class="playCircle">
                            <i class="fas fa-play"></i>
                        </div>
                        <h3>{{video.title}}</h3>
                    </div>
                </div>
            </div>
            <div class="videosLoad" v-if="loaded_videos.length < all_videos.length" @click="update(page + 1)">
                <i class="far fa-undo-alt"></i>
                Load more videos
            </div>
        </div>
    </div>
    <div v-else class="loader">
        <i class="fas fa-circle-notch fa-spin"></i>
    </div>
</template>

<script>
export default {
    props: [
        'videos',
    ],
    data() {
        return {
            loaded: false,
            all_videos: this.videos,
            page_size: 5,
            page: 1,
            loaded_videos: []
        };
    },
    mounted() {
        this.boot()
        this.update();
    },
    methods: {
        boot(){
            this.loaded = true;
        },
        update(page_number = 1){
            this.page = page_number;

            var videos = this.all_videos;
            this.loaded_videos = videos.slice(0, this.page_size * this.page);
        },
        openVideo(link) {
            window.open(link, '_blank');
        }
    }
}
</script>
